// extracted by mini-css-extract-plugin
export default {"thumb":"b_gOpALaxsqeT4TmkmQR","tagContainer":"UpZH_V3xAX3QO9Oew5ap"};